// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type SaveProjectCollaboratorMutationVariables = Types.Exact<{
  input: Types.SaveProjectCollaboratorInput;
}>;


export type SaveProjectCollaboratorMutation = { __typename?: 'Mutation', saveProjectCollaborator: { __typename?: 'EmptyResult', emptyResult?: string | null | undefined } };


export const SaveProjectCollaboratorDocument = gql`
    mutation SaveProjectCollaborator($input: SaveProjectCollaboratorInput!) {
  saveProjectCollaborator(input: $input) {
    emptyResult
  }
}
    `;
export type SaveProjectCollaboratorMutationFn = Apollo.MutationFunction<SaveProjectCollaboratorMutation, SaveProjectCollaboratorMutationVariables>;

/**
 * __useSaveProjectCollaboratorMutation__
 *
 * To run a mutation, you first call `useSaveProjectCollaboratorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveProjectCollaboratorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveProjectCollaboratorMutation, { data, loading, error }] = useSaveProjectCollaboratorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveProjectCollaboratorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveProjectCollaboratorMutation, SaveProjectCollaboratorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveProjectCollaboratorMutation, SaveProjectCollaboratorMutationVariables>(SaveProjectCollaboratorDocument, options);
      }
export type SaveProjectCollaboratorMutationHookResult = ReturnType<typeof useSaveProjectCollaboratorMutation>;
export type SaveProjectCollaboratorMutationResult = Apollo.MutationResult<SaveProjectCollaboratorMutation>;
export type SaveProjectCollaboratorMutationOptions = Apollo.BaseMutationOptions<SaveProjectCollaboratorMutation, SaveProjectCollaboratorMutationVariables>;